// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsScopes = {
  scopesTitle: "スコープ",
  scopes: {
    mine: "自分の資源",
    shared_with_me: "共有された資源",
    public: "公開",
    all: "すべて",
  },
} as const;
